import React, { useState } from "react";
import { FaTimesCircle } from "react-icons/fa";
import PopUp from "../../components/PopUp";
import { addBuilding } from "../../features/slices/buildingSlice";
import { createBuilding } from "../../apis/Building.Api";
import { useDispatch, useSelector } from "react-redux";
import { selectBuilding, selectUserData } from "../../features/store";
import { useSnackbar } from "notistack";
import { TextField } from "@mui/material";
import { RectBtn } from "../../components/General";

const AddBuilding = ({ setOpenAddBuilding, openAddBuilding }) => {
    const { enqueueSnackbar } = useSnackbar();

    const buildings = useSelector(selectBuilding);
    const [newBuildingId, setNewBuildingId] = useState("");
    const [newBuildingName, setNewBuildingName] = useState("");
    const [newBuildingIdError, setNewBuildingIdError] = useState("");
    const [newBuildingNameError, setNewBuildingNameError] = useState("");
    const dispatch = useDispatch();
    const userData = useSelector(selectUserData);

    async function confirmAddBuilding() {
        setNewBuildingIdError("");
        setNewBuildingNameError("");

        if (newBuildingId === "") {
            setNewBuildingIdError("Building ID cannot be empty");
            return;
        }
        if (newBuildingName === "") {
            setNewBuildingNameError("Building name cannot be empty");
            return;
        }
        if (buildings[newBuildingId]) {
            setNewBuildingIdError("Building ID must be unique");
            return;
        }
        for (let bid of Object.keys(buildings)) {
            if (buildings[bid].buildingName === newBuildingName) {
                setNewBuildingNameError("Building name must be unique");
                return;
            }
        }

        let r = await createBuilding({
            building_id: newBuildingId,
            building_name: newBuildingName,
        });
        if (r.data.networkError) {
            enqueueSnackbar(r.data.message, { variant: "error" });
            return;
        }

        if (!r.data.indicator) {
            enqueueSnackbar("Failed to add building. This is possibly due to duplicated building ID or name.", {
                variant: "error",
            });
            return;
        }
        enqueueSnackbar(r.data.message, { variant: "success" });
        dispatch(addBuilding({ buildingId: newBuildingId, buildingName: newBuildingName }));
        setOpenAddBuilding(false);
    }
    return (
        <PopUp width={60} height={45} switchOn={openAddBuilding}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Configure Building</h4>

                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setNewBuildingId("");
                            setNewBuildingName("");
                            setOpenAddBuilding(false);
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="add-building-wrapper">
                        <div className="fields">
                            <TextField
                                placeholder="Building ID"
                                onChange={(event) => {
                                    setNewBuildingId(event.target.value);
                                }}
                                value={newBuildingId}
                                inputProps={{ maxLength: 20 }}
                                label="Building ID"
                                error={newBuildingIdError !== ""}
                                helperText={newBuildingIdError}
                            ></TextField>
                            <TextField
                                placeholder="Building Name"
                                onChange={(event) => {
                                    setNewBuildingName(event.target.value);
                                }}
                                value={newBuildingName}
                                inputProps={{ maxLength: 30 }}
                                label="Building Name"
                                error={newBuildingNameError !== ""}
                                helperText={newBuildingNameError}
                            ></TextField>
                        </div>

                        <div className="add-building-btn-wrapper">
                            <RectBtn onClick={confirmAddBuilding}> Confirm </RectBtn>
                        </div>
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default AddBuilding;
